// src/components/LogoutButton.jsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for redirection

const LogoutButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate(); // Get navigate function from react-router

  const handleLogout = () => {
    logout(); // Call logout function to clear token and user data
    localStorage.removeItem("authToken"); // Remove token from local storage
    localStorage.removeItem("userData"); // Remove user data from local storage
    navigate('/'); // Redirect to login page
    window.location.reload(); // Reload the page to clear all states
  };

  return (

    <button
      onClick={handleLogout} // Log out user

      className="block lg:px-4 lg:py-2 lg:hover:bg-primary lg:hover:text-black flex items-center space-x-2"    >
      <i className="fas fa-sign-out-alt mr-2"></i>
      Logout
    </button>
  );
};

export default LogoutButton;
